module.exports = __webpack_public_path__ + "static/tests-9d6afdb4b17499442dd4443939a78e3c.jpg";